import React, { useEffect } from "react";

const ExamplePage = () => {

	useEffect(() => {
		console.log("ExamplePage mounted");
	}, []);

	return (
		<div className="home-page">
			<span>HELLO REACT</span>
			<img src={window.assetUrl('/images/backend/vector.png')} alt="" />
		</div>
	);
};

export default ExamplePage;
